// extracted by mini-css-extract-plugin
export const form = "bs_t";
export const dialog = "bs_b4";
export const titleTxt = "bs_b5";
export const content = "bs_R";